import React, { useRef, useState } from "react"
import { Form, Input, Label, Modal, Row } from "reactstrap"
import "../../assets/css/dashboard.css"
import addGsImg from "../../assets/images/settingImg/addGs.jpg"

const DashboardTabs = ({ onChangeTabs }) => {
  const [activeTab1, setactiveTab1] = useState("1")
  const [addTab, setAddTab] = useState(false)
  const [editTab, setEditTab] = useState(false)
  const [tab_name, setTabName] = useState("")
  const dragItem = useRef()
  const dragOverItem = useRef()

  const dragStart = (e, position) => {
    if (position === 0) return
    dragItem.current = position
  }

  const dragEnter = (e, position) => {
    if (position === 0) return
    dragOverItem.current = position
  }

  const [allTabs, setAllTabs] = useState([
    {
      id: 1,
      name: "Default Dashboard",
    },
  ])

  const Elements = [
    {
      name: "Sales",
      id: 1,
      inner: [
        {
          name: "Leads & Followups",
          checked: true,
        },
        {
          name: "Proposal List",
          checked: false,
        },
        {
          name: "Pending Contracts",
          checked: true,
        },
        {
          name: "Converted Customers",
          checked: false,
        },
      ],
    },
    {
      name: "Marketing",
      id: 1,
      inner: [
        {
          name: "Opportunitys",
          checked: true,
        },
        {
          name: "Cold Calling",
          checked: false,
        },
        {
          name: "Bookings",
          checked: true,
        },
      ],
    },
    {
      name: "Human Resources",
      id: 1,
      inner: [
        {
          name: "Punch Details",
          checked: false,
        },
        {
          name: "Leaves Management",
          checked: true,
        },
        {
          name: "Salary Sheet",
          checked: false,
        },
      ],
    },
    {
      name: "Work",
      id: 1,
      inner: [
        {
          name: "Resource Plannig",
          checked: true,
        },
        {
          name: "Timers",
          checked: false,
        },
        {
          name: "General Tasks",
          checked: true,
        },
        {
          name: "Tickets",
          checked: false,
        },
      ],
    },
    {
      name: "Audit Logs",
      id: 1,
      inner: [
        {
          name: "Roles & Permissions",
          checked: true,
        },
        {
          name: "Logins",
          checked: false,
        },
        {
          name: "Punch Logs",
          checked: true,
        },
        {
          name: "Cron Logs",
          checked: false,
        },
      ],
    },
    {
      name: "Finance",
      id: 1,
      inner: [
        {
          name: "Expenses",
          checked: true,
        },
        {
          name: "Inventory Information",
          checked: false,
        },
        {
          name: "Pending Invoices",
          checked: true,
        },
      ],
    },
  ]

  const drop = e => {
    if (dragItem.current === null || dragOverItem.current === null) return
    const copyListItems = [...allTabs]
    const dragItemContent = copyListItems[dragItem.current]
    copyListItems.splice(dragItem.current, 1)
    copyListItems.splice(dragOverItem.current, 0, dragItemContent)
    dragItem.current = null
    dragOverItem.current = null
    setAllTabs(copyListItems)
  }
  return (
    <div className="mb-3">
      <div>
        <div className="d-flex gap-3 justify-content-between align-items-center">
          <div className="d-flex gap-3 dashboard-tabs">
            {allTabs?.map((obj, i) => {
              return (
                <div
                  className={`tabs ${
                    activeTab1 == obj.id ? "active" : " "
                  } added-tabs`}
                  key={i}
                  onDragStart={e => dragStart(e, i)}
                  onDragEnter={e => dragEnter(e, i)}
                  onDragEnd={drop}
                  draggable={i !== 0}
                >
                  <a
                    className="d-flex align-items-center justify-content-between gap-3"
                    onClick={e => {
                      setactiveTab1(obj.id)
                      onChangeTabs(obj?.id, obj?.name)
                    }}
                  >
                    {obj?.name}
                    <a
                      className="edit-dashboard"
                      onClick={() => {
                        setTabName(obj.name)
                        setEditTab(true)
                      }}
                    >
                      <i className="fas fa-pen "></i>
                    </a>
                  </a>
                </div>
              )
            })}
          </div>
          <div className="add-dahsboard-tab">
            <div className="text-center">
              <a className="tabs active" onClick={() => setAddTab(true)}>
                <i className="fas fa-plus "></i>
              </a>
            </div>
            <div className="text-center ms-2">
              <a className="tabs active" title="Save Layout">
                <i className="fas fa-save "></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Add Dashboard Tabs */}
      <Modal
        isOpen={addTab}
        toggle={() => {
          tog_center()
        }}
        centered
        size="lg"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Add New Dashboard Tabs</h5>
          <button
            type="button"
            onClick={() => {
              setAddTab(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body">
          <Form
            onSubmit={e => {
              e.preventDefault()
              setAllTabs([
                ...allTabs,
                {
                  id: parseFloat(allTabs?.slice(-1)[0]?.id) + 1,
                  name: tab_name,
                },
              ])
              setAddTab(false)
            }}
          >
            <Row className="align-items-center">
              <div className="col-4">
                <img src={addGsImg} className="img-fluid" />
              </div>
              <div className="col-8 ">
                <div className="mb-3 col-12">
                  <Label htmlFor="formrow-firstname-Input">
                    Dashboard Tab Name
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="formrow-firstname-Input"
                    placeholder="Enter Dashboard Tab Name"
                    required
                    onChange={e => {
                      setTabName(e.target.value)
                    }}
                  />
                </div>
                <div className="text-end pt-3">
                  <button className=" btn btn-purple btn-label">
                    <i className="fas fa-save me-2 icon-size label-icon"></i>
                    Save
                  </button>
                  <button
                    type="button"
                    onClick={() => setAddTab(false)}
                    className=" btn ms-md-2 btn-red btn-label"
                  >
                    <i className="dripicons-cross me-2 icon-center label-icon"></i>
                    CANCEL
                  </button>
                </div>
              </div>
            </Row>
          </Form>
        </div>
      </Modal>

      <Modal
        isOpen={editTab}
        toggle={() => {
          tog_center()
        }}
        centered
        size="xl"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Dashboard Tab</h5>
          <button
            type="button"
            onClick={() => {
              setEditTab(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body">
          <Form>
            <Row>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="mb-3 col-5">
                  <Label htmlFor="formrow-firstname-Input">
                    Dashboard Tab Name
                  </Label>
                  <Input
                    type="text"
                    className="form-control"
                    id="formrow-firstname-Input"
                    placeholder="Enter Dashboard Tab Name"
                    value={tab_name}
                    onChange={e => setTabName(e.target.value)}
                    required
                  />
                </div>
                <div className="text-end">
                  <button className=" btn btn-purple btn-label">
                    <i className="fas fa-save me-2 icon-size label-icon"></i>
                    Save
                  </button>
                  <button
                    type="button"
                    className=" btn ms-md-2 btn-red btn-label"
                  >
                    <i className="dripicons-cross me-2 icon-center label-icon"></i>
                    Remove Tab
                  </button>
                </div>
              </div>
              <div>
                <Row>
                  <div className="col-md-6">
                    {Elements?.slice(0, 3)?.map((obj, i) => {
                      return (
                        <div key={i} className="mb-4 col-md-10">
                          <h5>{obj?.name}</h5>
                          {obj?.inner?.map((element, i) => {
                            return (
                              <div
                                className="d-flex justify-space-between align-items-center gap-2 mb-2"
                                key={i}
                              >
                                <span>
                                  <i className="bi bi-arrow-right pe-2"></i>
                                  {element?.name}
                                </span>
                                <div className="form-switch form-switch-md">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="customSwitchsizemd"
                                    defaultChecked={element?.checked}
                                  />
                                </div>
                              </div>
                            )
                          })}
                        </div>
                      )
                    })}
                  </div>
                  <div className="col-md-6">
                    {Elements?.slice(3, 6)?.map((obj, i) => {
                      return (
                        <div key={i} className="mb-4 col-md-10">
                          <h5>{obj?.name}</h5>
                          {obj?.inner?.map((element, i) => {
                            return (
                              <div
                                className="d-flex justify-space-between align-items-center gap-2 mb-2"
                                key={i}
                              >
                                <span>
                                  <i className="bi bi-arrow-right pe-2"></i>{" "}
                                  {element?.name}
                                </span>
                                <div className="form-switch form-switch-md">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="customSwitchsizemd"
                                    defaultChecked={element?.checked}
                                  />
                                </div>
                              </div>
                            )
                          })}
                        </div>
                      )
                    })}
                  </div>
                </Row>
              </div>
            </Row>
            <div className="border-bottom my-3"></div>
          </Form>
        </div>
      </Modal>
    </div>
  )
}

export default DashboardTabs
